import React from "react";

const AlertMessage = ({ type = "info", title, children, className = "" }) => {
	let themeClasses = "";
	let iconColor = "";

	switch (type) {
		case "warning":
			themeClasses = "bg-orange-50 border-orange-200 text-orange-700";
			iconColor = "#fd7e14";
			break;
		case "error":
			themeClasses = "bg-red-50 border-red-200 text-red-700";
			iconColor = "#dc3545";
			break;
		case "success":
			themeClasses = "bg-green-50 border-green-200 text-green-700";
			iconColor = "#198754";
			break;
		case "info":
		default:
			themeClasses = "bg-blue-50 border-blue-200 text-blue-700";
			iconColor = "#007bff";
			break;
	}

	return (
		<div className={`border rounded p-3 mt-3 d-flex align-items-center gap-3 ${themeClasses} ${className}`}>
			<svg
				style={{ width: "28px", height: "28px", minWidth: "28px", fill: "none", stroke: iconColor, strokeWidth: "2" }}
				viewBox="0 0 24 24"
			>
				<circle cx="12" cy="12" r="10" />
				<path strokeLinecap="round" strokeLinejoin="round" d="M12 16v-4m0-4h.01" />
			</svg>
			<div className="mb-0" style={{ fontSize: "14px", color: "inherit" }}>
				{title && <strong>{title}: </strong>}
				{children}
			</div>
		</div>
	);
};

export default AlertMessage;
